import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const UMContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
        overflow-x: auto;

     @media ${({ theme }) => theme.device.tabletL} {
       
    }
`
export const UMBody = styled.div`
    width: 100%;
    height: 100%;
    margin-top: 1rem;
    min-width:750px;
`

export const UserStatus = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 55px;
    border-radius: 6px;
    background-color: ${({bg}) => bg ? bg : "white"};
    color: ${({color}) => color ? color : theme.colors.lightBlack};
`

export const RequestLink = styled(Link)`
    color: ${({theme}) => theme.colors.lightBlack};
    text-decoration: none;
    &:hover{
        color: ${({theme}) => theme.colors.laightBlack};
    }
`

